// Device-type detection. We block phones & tablets from the operator app;
// only desktops/laptops are allowed. Detection is by user-agent + iPadOS touch
// heuristic (iPadOS 13+ masquerades as macOS). We deliberately do NOT block by
// screen size alone, to avoid false-positives on touch-enabled laptops.
export function isMobileOrTablet() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || navigator.vendor || window.opera || "";

  const phoneRe = /Android|webOS|iPhone|iPod|BlackBerry|BB10|IEMobile|Opera Mini|Mobile|Silk|Windows Phone/i;
  const tabletRe = /iPad|Tablet|PlayBook|Nexus 7|Nexus 10|KFAPWI|SM-T|Kindle/i;
  if (phoneRe.test(ua) || tabletRe.test(ua)) return true;

  // iPadOS 13+ reports as "MacIntel" but exposes multi-touch.
  const isIpadOS =
    (navigator.platform === "MacIntel" || /Mac/i.test(ua)) &&
    (navigator.maxTouchPoints || 0) > 1;
  if (isIpadOS) return true;

  return false;
}
